
import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import Stepper from "@/components/Stepper.vue";
@Component({
    components: {Stepper},
})
export default class RelayStatus extends Vue {
    @Prop({default: null})
    public relay: any;

    private newInfo: any = {};
    private isEdit: boolean = false;
    private loadingSaveRelay: boolean = false;

    get status() {
        const statusB2B: any = [
            {value: 0, label: "relay.status.AGENCY.0"},
            {value: 1, label: "relay.status.AGENCY.1"},
            {value: 2, label: "relay.status.AGENCY.2"},
        ];
        const statusB2C: any = [
            {value: 0, label: "relay.status.FLOW.0"},
            {value: 1, label: "relay.status.FLOW.1"},
            {value: 2, label: "relay.status.FLOW.2"},
            {value: 3, label: "relay.status.FLOW.3"},
            {value: 4, label: "relay.status.FLOW.4"},
        ];
        return this.isAgency ? statusB2B : statusB2C;
    }

    get isAgency(): boolean {
        return this.relay?.type === "AGENCY";
    }

    private async showEdit() {
        this.newInfo = await JSON.parse(JSON.stringify(this.relay));
        this.isEdit = true;
    }

    private closeEdit() {
        this.isEdit = false;
    }

    private async save() {
      this.loadingSaveRelay = true;
      this.newInfo.referents = this.newInfo.Referents.map((ref) => ref.id);
      delete this.newInfo.Boxes;
      await this.$store.dispatch("relays/update", {
          id: this.relay.id,
          relay: this.newInfo,
        }).then(async (res) => {
          this.$store.commit("alerts/displaySuccess", {
            msg: this.$i18n?.t("actions.saved"),
          });
          this.$emit("reset");
          this.closeEdit();
        }).catch((err) => {
          this.$store.commit("alerts/displayError", {
            msg: err?.response?.data?.error || err,
          });
        }).finally(() => {
          this.loadingSaveRelay = false;
        });
    }

}
